import api from '@/api';

import { PageResult } from '@/core/request/PageResult';
import { PageRequest } from '@/core/request/PageRequest';

import {
  BankAccount,
  BankAccountFilter,
  CreateBankAccountRequest,
  UpdateBankAccountRequest,
} from './BankAccounts.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/bankAccounts`;

export async function listBankAccounts(
  params?: PageRequest,
): Promise<PageResult<BankAccount>> {
  const result = (await api.get(`${CONTROLLER_URL}/matrix`, params)) as unknown;

  return result as PageResult<BankAccount>;
}
export async function listBankAccountsFilter(
  params?: PageRequest,
): Promise<PageResult<BankAccountFilter>> {
  const result = (await api.get(`${CONTROLLER_URL}/filter`, params)) as unknown;

  return result as PageResult<BankAccountFilter>;
}

export async function getBankAccount(id?: number): Promise<BankAccount> {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, null)) as unknown;

  return result as BankAccount;
}

export async function createBankAccount(
  obj: CreateBankAccountRequest,
): Promise<BankAccount> {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as BankAccount;
}

export async function updateBankAccount(
  obj: UpdateBankAccountRequest,
): Promise<BankAccount> {
  const result = (await api.put(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as BankAccount;
}

export async function updateStatusBankAccount(
  id: number,
): Promise<BankAccount> {
  const result = (await api.put(
    `${CONTROLLER_URL}/${id}/active`,
    {},
    null,
  )) as unknown;

  return result as BankAccount;
}

export async function deleteBankAccount(id: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${id}`,
    {},
    null,
  )) as unknown;

  return result;
}
